import { registerQuery } from 'data-fetching-client';
import { fetchValidCurrencies } from './validCurrenciesApi';
export const GET_VALID_CURRENCIES = registerQuery({
  fieldName: 'currencyData',
  args: [],
  fetcher: fetchValidCurrencies
});